import { db } from '../config/firebase';
import { addDoc, collection, serverTimestamp, query, where, getDocs, limit } from 'firebase/firestore';

/**
 * Registra un acceso (login exitoso) en `servicios/{servicioId}/accesos`.
 *
 * Best-effort: cualquier error se traga en silencio para NO romper el login.
 * Resuelve empresa/delegación desde la ficha del vigilante (por `email`), que
 * es lo que el dashboard usa para el filtro por rol (inspector).
 *
 * @param {Object} params
 * @param {string} params.servicioId
 * @param {Object} params.user - Usuario de Firebase Auth (email, uid).
 * @param {string} [params.origen='web']
 */
export const registrarAcceso = async ({ servicioId, user, origen = 'web' }) => {
  try {
    if (!servicioId || !user) return;
    const email = (user.email || '').toLowerCase().trim();

    const datos = { nombre: '', apellidos: '', codEmpresa: '', empresaNombre: '', delegacion: '' };
    if (email) {
      try {
        const vSnap = await getDocs(query(
          collection(db, 'servicios', servicioId, 'vigilantes'),
          where('email', '==', email),
          limit(1)
        ));
        if (!vSnap.empty) {
          const v = vSnap.docs[0].data() || {};
          datos.nombre = v.nombre || '';
          datos.apellidos = v.apellidos || '';
          datos.codEmpresa = v.codEmpresa || '';
          datos.empresaNombre = v.empresaNombre || '';
          datos.delegacion = v.delegacion || '';
        }
      } catch (_e) { /* enriquecimiento opcional */ }
    }

    await addDoc(collection(db, 'servicios', servicioId, 'accesos'), {
      email,
      uid: user.uid || '',
      origen,
      timestamp: serverTimestamp(),
      ...datos,
    });
  } catch (_e) {
    // best-effort: nunca romper el login.
  }
};
